import React from 'react';
import useAccordionPanel from './useAccordionPanel';

type AccordionPanelProps = Readonly<{
  children?: React.ReactNode;
  id: string;
  isActive: boolean;
  labelledBy: string;
}>;

/**
 * Panel colapsable del Accordion. Expone la relación de accesibilidad con su
 * cabecera (`role="region"` + `aria-labelledby`) y delega la animación de
 * altura en `useAccordionPanel`.
 */
function AccordionPanel({ children, id, isActive, labelledBy }: AccordionPanelProps): JSX.Element {
  const { maxHeight, sectionRef } = useAccordionPanel({ children, isActive });

  // <section> con nombre accesible (aria-labelledby) expone `role="region"` de
  // forma implícita, sin necesidad del atributo `role` explícito.
  return (
    <section ref={sectionRef} aria-labelledby={labelledBy} className="ui-accordion__panel" id={id} style={{ maxHeight }}>
      {children}
    </section>
  );
}

export default AccordionPanel;
